import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoDialogService, PoNotificationService } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { User } from '../interfaces/user.model';
import { LiteralsService } from './literals-service';
import { SellersService } from './sellers.service';
import { SetupSyncService } from './setup-sync.service';
import { Functions } from '../functions/functions';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  loggedUser: User;
  literals: LiteralsWords;
  readonly tbUser = 'users';

  constructor(
    private poStorageService: PoStorageService,
    private setupSyncService: SetupSyncService,
    private literalsService: LiteralsService,
    private poNotification: PoNotificationService,
    private poDialog: PoDialogService,
    private sellersService: SellersService,
    private functions: Functions
  ) {
    this.literals = this.literalsService.getLiteralModule();
    this.poNotification.setDefaultDuration(5000);
  }

  async initialPoStorage(idUser: string): Promise<void | User> {
    return await this.poStorageService
      .exists(this.tbUser)
      .then(async exist => {
        if (!exist) {
          await this.newUser(idUser);
        } else {
          await this.getUserStorage(idUser)
            .then(async user => {
              if (!user) {
                return await this.newUser(idUser);
              }
              this.sellersService
                .setSeller()
                .then(response => response)
                .catch(error => {
                  if (error?.name !== 'EmptyError') {
                    this.poNotification.error(error);
                  }
                });
              return (this.loggedUser = user);
            })
            .catch(error => {
              if (error?.name !== 'EmptyError') {
                this.poNotification.error(error);
              }
            });
        }
      })
      .catch(error =>
        this.poNotification.error(this.literals.str0063 + error)
      );
  }

  async existUser(idUser: string): Promise<boolean> {
    return await new Promise((resolve, reject) => {
      this.setupSyncService.prepareSync()
        .then(() => {
          this.initialPoStorage(idUser);
          resolve(true);
        })
        .catch(error => {
          if (error && !(error instanceof HttpErrorResponse) && !this.functions.checkVersion('1.4.1')) {
            this.poDialog.alert({ title: this.literals.str0506, message: this.literals.str0500 });
          }
          reject(false);
        });
    });
  }

  async newUser(idUser): Promise<void> {
    const userInfo = {
      id: idUser,
      name: idUser,
      email: '',
      load: false
    };
    this.loggedUser = userInfo;
    await this.addUser(userInfo);
  }

  async addUser(userInfo: User): Promise<void> {
    await this.poStorageService
      .appendItemToArray(this.tbUser, userInfo)
      .catch(error => this.poNotification.error(error));
  }

  async loadAsyncData(): Promise<void> {
    await this.setupSyncService.reloadAsync();
  }

  async getUserStorage(idUser): Promise<User> {
    return this.poStorageService.getItemByField(this.tbUser, 'id', idUser);
  }

  getUser(): User {
    return this.loggedUser;
  }
}
